exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-toggler{display:none}.c-menu{margin-bottom:1rem}.c-menu__container{display:none;list-style:none;margin:0}.menu-toggler:checked~.c-menu__container{display:block}@media (min-width:60em){.c-menu__container.c-menu__container--main{display:block}}", ""]);

// exports
